import React, { useState, useEffect } from "react";
import { Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../context/AppContext";
import EditableForm from "../EditableForm";
import { updateCompany } from "../../api/userCompanies";


const CompanyDetailsTab = () => {
    const { t } = useTranslation();
    const { user, setIsLoading, setUser } = useAppContext();

    const [form, setForm] = useState({
        name: "",
        fiscal_code: "",
        address: "",
        country: "",
        industry: "",
        founded_at: "",
        contact_person_name: "",
        contact_person_email: "",
        contact_person_phone: "",
    });

    useEffect(() => {
        if (user?.company) {
            const {
                name = "",
                fiscal_code = "",
                address = "",
                country = "",
                industry = "",
                founded_at = "",
                contact_person_name = "",
                contact_person_email = "",
                contact_person_phone = "",
            } = user.company;

            const formattedDate = founded_at
                ? new Date(founded_at).toISOString().split("T")[0]
                : "";

            setForm({
                name,
                fiscal_code,
                address,
                country,
                industry,
                founded_at: formattedDate,
                contact_person_name,
                contact_person_email,
                contact_person_phone,
            });
        }
    }, [user]);

    const handleSubmit = async (data) => {
        if (!user?.company?.id) return;
        setIsLoading(true);
        try {
            const response = await updateCompany(user.company.id, data);
            setUser(prev=> ({
                ...prev,
                company: response,
            }))
            // Optionally: trigger a refetch or toast here
        } catch (err) {
            console.error("Update failed:", err);
        } finally {
            setIsLoading(false);
        }
    };

    const fields = [
        { name: "name", label: t("companySettings.fields.name") },
        { name: "fiscal_code", label: t("companySettings.fields.fiscal_code") },
        { name: "address", label: t("companySettings.fields.address") },
        { name: "country", label: t("companySettings.fields.country") },
        { name: "industry", label: t("companySettings.fields.industry") },
        { name: "founded_at", label: t("companySettings.fields.founded_at"), type: "date" },
        { name: "contact_person_name", label: t("company.contact_person_name") },
        { name: "contact_person_email", label: t("company.contact_person_email") },
        { name: "contact_person_phone", label: t("company.contact_person_phone") },
    ];

    return (
        <Box>
            <Typography
                variant="h5"
                gutterBottom
                sx={{ fontWeight: 600, color: "#000" }}
            >
                {t("companySettings.details")}
            </Typography>

            <Box mt={3}>
                <EditableForm
                    data={form}
                    fields={fields}
                    onChange={setForm}
                    onSubmit={handleSubmit}
                />
            </Box>
        </Box>
    );
};

export default CompanyDetailsTab;
